module.exports = __webpack_public_path__ + "static/people_img14-7d522e9f4f3ab0f1d670b639456e9ae7.png";